import { validStyles } from "@tamagui/helpers";
import { stackDefaultStyles } from "../constants/constants.mjs";
import { createComponent } from "../createComponent.mjs";
const Stack = createComponent({
  acceptsClassName: !0,
  defaultProps: stackDefaultStyles,
  validStyles
});
Stack.displayName = "Stack";
export { Stack };
//# sourceMappingURL=Stack.mjs.map
